<template>
  <div>
    <div v-if="showBillDetailEntry" class="balance-detail">
      <div class="bd-title">
        <span class="bd-title-l">余额明细</span>
      </div>

      <ul class="bd-list">
        <li class="bd-item" @click="openDetailThrottly">
          <div class="bd-item-info">
            <p class="bd-item-info-title ellipsis">{{ detail.billDesc }}</p>
            <p class="bd-item-info-time ellipsis">{{ detail.tradeTime }}</p>
          </div>
          <div class="bd-item-amount ellipsis">
            <div class="bd-item-amount-text">{{ detail.type === TradeType.Income ? '+' : '-' }}{{ detail.amount }}</div>
            <img class="bd-item-amount-icon" src="../../../assets/back-right-black.png" alt=">" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { bridge, analytics, analyticConfig, env, monitor, throttle, getUrl, TradeType } from '@/common';

export default Vue.extend({
  name: 'BalanceDetail',

  props: {
    detail: {
      default: () => ({} as ILatestDetail),
      type: Object as PropType<ILatestDetail>,
    },
  },

  data() {
    return {
      TradeType,
      openDetailThrottly: () => {
        monitor.captureJSErrorMessage('余额首页, 兜底点击跳转交易详情, 触发兜底逻辑');
      },
    };
  },

  computed: {
    showBillDetailEntry(): boolean {
      return !!this.detail?.tradeNo;
    },
  },

  created() {},

  mounted() {
    this.openDetailThrottly = throttle(this.openDetail, 2000);
    this.mv();
  },

  methods: {
    openDetail() {
      analytics.addTag(
        {
          bid: analyticConfig.balanceDetailMc,
          from: env.scene,
          utm_source: env.utmSource,
        },
        analyticConfig.index.cid
      );
      analytics.click(analyticConfig.balanceDetailMc);
      if (env.isNative) {
        bridge.openPage(getUrl(`/record.html?scene=${env.scene}`));
      } else {
        bridge.openPage(getUrl(`/record.html${window.location.search}`));
      }
    },

    mv() {
      analytics.mv(analyticConfig.balanceDetailMv, {
        id: this.detail?.tradeNo || '',
      });
    },
  },
});
</script>

<style lang="less" scoped>
.balance-detail {
  background: #fff;
  border-radius: 0.24rem;
  padding: 0.3rem 0.24rem;
  .bd-title {
    .bd-title-l {
      line-height: 0.32rem;
      font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 0.32rem;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.9);
    }
  }
  .bd-list {
    margin-top: 0.06rem;
  }
  .bd-item {
    display: flex;
    justify-content: space-between;
    position: relative;
    .bd-item-info {
      width: 4.9rem;
      overflow: hidden;
      display: flex;
      align-items: center;

      p {
        margin: 0;
      }

      .bd-item-info-title {
        font-size: 0.22rem;
        color: #191919;
        margin-right: 0.12rem;
      }

      .bd-item-info-time {
        font-size: 0.22rem;
        color: #999;
      }
    }

    .bd-item-amount {
      display: flex;
      align-items: center;

      .bd-item-amount-text {
        text-align: right;
        font-family: 'MTNewDigitalDisplay-Medium', monospace;
        font-size: 0.24rem;
        color: #191919;
        position: relative;
        top: 0.02rem;
      }

      .bd-item-amount-icon {
        width: 0.24rem;
        height: 0.24rem;
        margin-left: 0.04rem;
      }
    }
  }

  .empty {
    height: 0.4rem;
    line-height: 0.4rem;
    font-size: 0.28rem;
    color: rgba(0, 0, 0, 0.8);
    margin: 0.21rem 0 0.3rem;
  }
}
</style>
